"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Context_1 = require("../../Context");
function useBoolValueValidation(name) {
    var _a = (0, Context_1.useFormContext)(), initialValues = _a.initialValues, values = _a.values;
    if (!(name in initialValues && typeof initialValues[name] === 'boolean')) {
        throw new Error("Field " + name + " needs a default boolean value in form initialValues");
    }
    if (typeof values[name] !== 'boolean') {
        throw new Error("Field " + name + " needs boolean value");
    }
}
exports.default = useBoolValueValidation;
